import React from 'react';
import { cn } from '@/shared/utils/cn';

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------
type BadgeVariant = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

export interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
  className?: string;
}

// ---------------------------------------------------------------------------
// Style map
// ---------------------------------------------------------------------------
const variantClasses: Record<BadgeVariant, string> = {
  success: 'bg-secondary-100 text-secondary-700 ring-secondary-600/20',
  warning: 'bg-warning-100 text-warning-700 ring-warning-600/20',
  danger: 'bg-danger-100 text-danger-700 ring-danger-600/20',
  info: 'bg-primary-100 text-primary-700 ring-primary-600/20',
  neutral: 'bg-slate-100 text-slate-600 ring-slate-500/20',
};

// ---------------------------------------------------------------------------
// Badge component
// ---------------------------------------------------------------------------
function Badge({
  variant = 'neutral',
  children,
  className,
}: BadgeProps): React.ReactElement {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2.5 py-0.5',
        'text-xs font-medium ring-1 ring-inset',
        variantClasses[variant],
        className,
      )}
    >
      {children}
    </span>
  );
}

export default Badge;
